/* Favoritos tema base — localStorage, sin apps externas */
(function () {
  var KEY = 'theme_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? btn.dataset.labelRemove : btn.dataset.labelSave;
      if (label) btn.setAttribute('aria-label', label);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      /* En el header el badge se oculta si no hay nada; en la página de
         favoritos lo que sobra es la frase entera («0 productos guardados»
         debajo del título no aporta), así que se oculta el contenedor. */
      var frase = el.closest('[data-wishlist-count-line]');
      if (frase) frase.hidden = list.length === 0;
      else el.style.display = list.length ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    paint();
  });

  document.addEventListener('wishlist:change', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* Página de favoritos: pinta las mismas tarjetas que colecciones (product-card vía ?view=card) */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    var empty = document.querySelector('[data-wishlist-empty]');
    var favs = read();
    if (!favs.length) {
      if (empty) empty.style.display = '';
      return;
    }
    Promise.all(favs.map(function (handle) {
      return fetch('/products/' + handle + '?view=card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    })).then(function (cards) {
      cards.forEach(function (html) { if (html) grid.insertAdjacentHTML('beforeend', html); });
      paint();
      document.addEventListener('wishlist:change', function () {
        var l = read();
        grid.querySelectorAll('.product-card').forEach(function (card) {
          var btn = card.querySelector('[data-wishlist-toggle]');
          var h = btn && btn.getAttribute('data-handle');
          if (h && l.indexOf(h) === -1) card.remove();
        });
        if (!read().length && empty) empty.style.display = '';
      });
    });
  }
})();
